import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { withStyles } from '@material-ui/core/styles/index';
import red from '@material-ui/core/colors/red';
import Transition from './Transition';
import FMPText from '../pureForm/FMPText';

const styles = (theme) => ({
	dialogPaper: {
		overflow: 'scroll',
		width: '60%',
		maxWidth: '90%',
	},
	explanation: {
		padding: '0 0 10px 0',
	},
	lockedWarning: {
		marginTop: 10,
		padding: 10,
		fontWeight: 600,
		backgroundColor: red[50],
		border: `1px solid ${red[200]}`,
		borderRadius: 4,
	},
	question: {
		padding: '20px 20px 10px 20px',
		fontWeight: 600,
		fontSize: 16,
		textAlign: 'right',
	},
	actions: {
		padding: 10,
	},
	warningButton: {
		borderRadius: 100,
		color: theme.palette.getContrastText(red[500]),
		backgroundColor: red[500],
		'&:hover': {
			backgroundColor: red[700],
		},
	},
});

/**
 * Confirm editing a delivery whose invoice has already been issued.
 * Collects the required reason and hands it to onConfirm(reason).
 */
class ConfirmLockedDeliveryEditDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			reason: '',
			reasonError: undefined,
		};
	}

	handlePureChange = (value) => {
		this.setState({ reason: value, reasonError: undefined });
	};

	handleClose = () => {
		this.setState({ reason: '', reasonError: undefined });
		this.props.onClose();
	};

	handleConfirm = () => {
		const { onConfirm } = this.props;
		const reason = this.state.reason.trim();

		if (!reason) {
			this.setState({ reasonError: 'A reason for changing this delivery is required.' });
			return;
		}

		this.setState({ reason: '', reasonError: undefined });
		onConfirm(reason);
	};

	render() {
		const { classes, open } = this.props;
		return (
			<Dialog
				maxWidth="md"
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{
					paper: classes.dialogPaper,
				}}
			>
				<DialogTitle>Edit Invoiced Delivery</DialogTitle>
				<DialogContent>
					<div className={classes.explanation}>
						An invoice has already been issued for this delivery, so it is a locked record
						of what was actually dispatched.
					</div>

					<div className={classes.lockedWarning}>
						Changing it will NOT update the issued invoice — the invoice may no longer
						match the delivery. Your name and the reason below are recorded with each
						changed field.
					</div>

					<FMPText
						path="reason"
						value={this.state.reason}
						error={this.state.reasonError}
						onChange={this.handlePureChange}
						md={12}
						label={'Reason for changing this invoiced delivery'}
					/>
				</DialogContent>

				<div className={classes.question}>
					Are you sure you want to change this invoiced delivery?
				</div>

				<DialogActions>
					<div className={classes.actions}>
						<Button onClick={this.handleClose}>Close</Button>
						<Button
							variant="contained"
							onClick={this.handleConfirm}
							className={classes.warningButton}
						>
							Yes, change invoiced delivery
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		);
	}
}

ConfirmLockedDeliveryEditDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,
};

export default _.flow([withStyles(styles), withMobileDialog()])(ConfirmLockedDeliveryEditDialog);
